export type PricePlanBadge = {
  id: number
  label: string
  color: string
}

export enum PricePlanTypes {
  Recommended = 'recommended',
}

export enum PricePlanDurationPeriod {
  Monthly = 'monthly',
  Quarterly = 'quarterly',
  SemiAnnually = 'semiAnnually',
  Annually = 'annually',
  Unknown = 'unknown',
}

export type PricePlan = {
  id: number
  stripePlan: string
  stripeProduct: string
  title: string
  price: number
  pricePerMonth: number
  durationMonths: number
  currency: string
  trialDurationDays: number
  badges?: PricePlanBadge[]
  types: PricePlanTypes[]
}

export const hasPricesTrial = (prices: PricePlan[] | null): boolean => {
  if (!prices) {
    return false
  }

  return prices?.some((price) => !!price.trialDurationDays)
}

export const getTrialDuration = (prices: PricePlan[] | null): number => {
  if (!prices) {
    return 0
  }

  const { trialDurationDays = 0 } = prices?.find((price) => price.trialDurationDays) || {}

  return trialDurationDays
}
